/**
 * Likőr fajtája
 */
export type LiqueurFruitHerbal = 'FRUIT_LIQUEUR' | 'HERBAL_LIQUEUR' | 'OTHER';

export const LiqueurFruitHerbal = {
  FruitLiqueur: 'FRUIT_LIQUEUR' as LiqueurFruitHerbal,
  HerbalLiqueur: 'HERBAL_LIQUEUR' as LiqueurFruitHerbal,
  Other: 'OTHER' as LiqueurFruitHerbal,
};
